import { ReactNode } from "react"
import { Box, BoxProps } from "@chakra-ui/react"

import StbtcSuccessScreenBody from "./StbtcSuccessScreenBody"
import StbtcSuccessScreenHeader from "./StbtcSuccessScreenHeader"

type StbtcSuccessScreenProps = {
  header: ReactNode
  headerLogo?: string
  children?: ReactNode
  bodyProps?: BoxProps
}

export default function StbtcSuccessScreen({
  header,
  headerLogo,
  children,
  bodyProps,
}: StbtcSuccessScreenProps) {
  return (
    <Box rounded="24px" overflow="hidden" w="522px">
      <StbtcSuccessScreenHeader logo={headerLogo}>
        {header}
      </StbtcSuccessScreenHeader>
      {children && (
        <StbtcSuccessScreenBody {...bodyProps}>
          {children}
        </StbtcSuccessScreenBody>
      )}
    </Box>
  )
}
